import * as Scrivito from "scrivito";
import ImageOrVideo from "^/Components/ImageOrVideo";
import formatDate from "^/utils/formatDate";
import I18n from "^/config/i18n";

function Story({ story }) {
  const date = story.get("publishFromDate");

  return (
    <article className="teaser-box --inList">
      <Scrivito.LinkTag to={story} className="teaser-box__wrapper row bg-white">
        <ImageOrVideo
          widget={story}
          teaser={true}
          className="col-12 col-md-4"
        />
        <div className="teaser-box-content col-12 col-md-8">
          <div className="teaser-box__additional">
            {story.get("author")}
            <span>
              {" "}
              | (
              <time dateTime={date?.toISOString?.() ?? ""}>
                {formatDate(date, "DD.MM.YYYY")}
              </time>
              )
            </span>
          </div>
          <Scrivito.ContentTag
            content={story}
            attribute="title"
            tag="h4"
            className="teaser-box__title"
          />
          <Scrivito.ContentTag
            content={story}
            attribute="shortDescription"
            tag="div"
            className="teaser-box__description"
          />
          <span className="teaser-box__button">
            <i className="las la-angle-right me-2"></i>
            {I18n.t("news to news")}
          </span>
        </div>
      </Scrivito.LinkTag>
    </article>
  );
}
export default Scrivito.connect(Story);
